/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import { skillOverridesControllerFindAll } from "./skillOverridesControllerFindAll";
import { skillOverridesControllerRemove } from "./skillOverridesControllerRemove";
import { skillOverridesControllerUpsert } from "./skillOverridesControllerUpsert";

export function skillOverridesService() {
  return { skillOverridesControllerFindAll, skillOverridesControllerUpsert, skillOverridesControllerRemove }
}